import React, { memo } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { Nav4RecommendationsOld$key } from '@atlassian/jira-relay/src/__generated__/Nav4RecommendationsOld.graphql.ts';
import { PACKAGE_NAME, TEAM_NAME } from './constants.tsx';
import { Nav4RecommendationsOld as Nav4RecommendationsOldWithoutErrorBoundary } from './ui/Nav4RecommendationsOld.tsx';
import { Nav4Recommendations as Nav4RecommendationsWithoutErrorBoundary } from './ui/Nav4Recommendations.tsx';

export const Nav4Recommendations = memo(RecommendationsQuery);
export const Nav4RecommendationsOld = memo(RecommendationsOld);

type RecommendationProps = {
	queryRef: Nav4RecommendationsOld$key;
};

function RecommendationsOld({ queryRef }: RecommendationProps) {
	return (
		<JSErrorBoundary
			id="growth-recommendation-old"
			fallback="flag"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<Placeholder name="recommendations">
				<Nav4RecommendationsOldWithoutErrorBoundary queryRef={queryRef} />
			</Placeholder>
		</JSErrorBoundary>
	);
}

function RecommendationsQuery() {
	return (
		<JSErrorBoundary
			id="growth-recommendations"
			fallback="unmount"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<Placeholder name="recommendations">
				<Nav4RecommendationsWithoutErrorBoundary />
			</Placeholder>
		</JSErrorBoundary>
	);
}
